import {post} from "../modules/ajax";
import {isDesktop} from "../modules/devices";
import {isPremiumUser} from "./user";
import {
    calculateCustomSizePrice,
    calculatePrice, convertSvgToBase64,
    getSizesPrices,
    getSvgPreviewImage,
    sendEventsAddToCart,
    trackProductPageGa4Events
} from "./product";
import {formatPrice} from "./price";
import {fadeIn, fadeOut, hideElement, showElement, slideDown, slideUp} from "./element-visibility";
import {addItem, addItems, openCart, updateItemsNumber} from "./cart";
import {hideOffcanvasByDomObject, showOffcanvasByDomObject} from "./offcanvas";
import {ga4TrackSimpleEvent} from "../modules/analytics";
import EmblaCarousel from "embla-carousel";

let imageSliders = [];

export function updateList(type, filters, query, url, imageDisplay)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product-list/update',
            {
                type: type,
                filters: filters,
                q: query,
                url: url,
                imageDisplay: imageDisplay
            },
            function (data) {
                resolve(data);
            },
            function (error) {
                resolve([]);
            }
        );
    });
}

export function initCombinationSuggestions(combinationSuggestions)
{
    if (combinationSuggestions) {
        initHorizontalCarousel(combinationSuggestions, combinationSuggestions.closest('.embla-container'), true);
    }
}

function initHorizontalCarousel(carousel, emblaContainer, hasPagination)
{
    if (carousel.classList.contains('embla-initialized')) return;

    let emblaPrevButton = emblaContainer.querySelector('.embla-prev-button');
    let emblaNextButton = emblaContainer.querySelector('.embla-next-button');
    let emblaPaginator = emblaContainer.querySelector('.embla-pagination');
    let emblaCarousel = EmblaCarousel(
        carousel,
        {
            loop: true,
            breakpoints: {
                '(min-width: 992px)': {
                    loop: false,
                    slidesToScroll: 'auto',
                    watchDrag: false
                }
            }
        }
    );

    if (emblaPrevButton) {
        emblaPrevButton.addEventListener('click', function(e) {
            e.preventDefault();
            emblaCarousel.scrollPrev();
        });
    }

    if (emblaNextButton) {
        emblaNextButton.addEventListener('click', function(e) {
            e.preventDefault();
            emblaCarousel.scrollNext();
        });
    }

    emblaCarousel.on('init', function() {
        if (emblaCarousel.canScrollNext() && emblaNextButton) emblaNextButton.classList.add('d-lg-block');
        if (emblaCarousel.canScrollPrev() && emblaPrevButton) emblaPrevButton.classList.add('d-lg-block');
        carousel.classList.add('embla-initialized');
    });

    emblaCarousel.on('select', function() {
        if (emblaPrevButton) {
            if (emblaCarousel.canScrollPrev() && !emblaPrevButton.classList.contains('d-lg-block')) {
                emblaPrevButton.classList.add('d-lg-block');
            }
            if (!emblaCarousel.canScrollPrev() && emblaPrevButton.classList.contains('d-lg-block')) {
                emblaPrevButton.classList.remove('d-lg-block');
            }
        }

        if (emblaNextButton) {
            if (emblaCarousel.canScrollNext() && !emblaNextButton.classList.contains('d-lg-block')) {
                emblaNextButton.classList.add('d-lg-block');
            }
            if (!emblaCarousel.canScrollNext() && emblaNextButton.classList.contains('d-lg-block')) {
                emblaNextButton.classList.remove('d-lg-block');
            }
        }

        if (!hasPagination || !emblaPaginator) return;

        let previousSlideIndex = emblaCarousel.previousScrollSnap();
        let nextSlideIndex = emblaCarousel.selectedScrollSnap();
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.remove('bg-black');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${previousSlideIndex}"]`).classList.add('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.remove('bg-gray-light');
        emblaPaginator.querySelector(`.embla-pagination-element[data-slide-index="${nextSlideIndex}"]`).classList.add('bg-black');
    });

    if (hasPagination) {
        let slidesLoaded = [];
        emblaCarousel.on('slidesInView', function() {
            let slidesInView = emblaCarousel.slidesInView().filter((index) => !slidesLoaded.includes(index));

            slidesInView.forEach(function(slideIndex) {
                let slide = emblaCarousel.slideNodes()[slideIndex];
                if (!slide) return;
                let img = slide.querySelector('img');
                let loader = slide.querySelector('.loader');

                if (!img || !img.dataset.src) return;

                img.src = img.dataset.src;
                img.addEventListener('load', function() {
                    if (loader) loader.classList.add('d-none');
                    slidesLoaded.push(slideIndex);
                });
            });
        });
    }
}

export function updateImageDisplay(type)
{
    let productsImages = document.querySelectorAll('.product-images');
    productsImages.forEach((productImages) => productImages.dataset.type = type);
}

export function displayProductProductListImages()
{
    imageSliders.forEach((slider) => slider.scrollTo(slider.slideNodes().length - 1, true));
}

export function displayRoomProductListImages()
{
    imageSliders.forEach((slider) => slider.scrollTo(0, true));
}

export function getFilters(container)
{
    let filters = {};

    container.querySelectorAll('input[name="filter"]:checked').forEach(function(filter) {
        let value = filter.value;
        if (value === '') return;
        let type = filter.dataset.type;

        if (type === 'newProducts') {
            filters[type] = value;
        } else {
            if (!filters.hasOwnProperty(type)) filters[type] = [];
            if (!filters[type].includes(value)) filters[type].push(value);
        }
    });

    return filters;
}

export function initProductImageSliders(container, imageDisplay)
{
    container.querySelectorAll('.product .embla-carousel').forEach(function(slider) {
        initProductImageSlider(slider, imageDisplay);
    });
}

export function initProductImageSlider(slider, imageDisplay, forcedImageDisplay = false)
{
    let emblaContainer = slider.closest('.embla-container');
    let emblaPrevButton = emblaContainer.querySelector('.embla-prev-button');
    let emblaNextButton = emblaContainer.querySelector('.embla-next-button');
    let productImageDisplay = emblaContainer.dataset.imageDisplay || imageDisplay;
    if (forcedImageDisplay) productImageDisplay = imageDisplay;
    let emblaCarousel = EmblaCarousel(
        slider,
        {
            loop: true,
            align: 'start',
            startIndex: productImageDisplay === 'product' ? slider.querySelectorAll('.embla-slide').length - 1 : 0
        }
    );

    emblaPrevButton.addEventListener('click', function(e) {
        e.preventDefault();
        emblaCarousel.scrollPrev();
    });

    emblaNextButton.addEventListener('click', function(e) {
        e.preventDefault();
        emblaCarousel.scrollNext();
    });

    emblaCarousel.on('init', function() {
        if (emblaCarousel.canScrollNext()) emblaNextButton.classList.remove('d-none');
        if (emblaCarousel.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
        emblaContainer.classList.add('embla-initialized');
    });

    imageSliders.push(emblaCarousel);
}

export function updateExclusivePremiumProducts(container)
{
    let products = container.querySelectorAll('.product.exclusive-premium-product');
    let isPremium = isPremiumUser();

    if (!products || isPremium) return;

    products.forEach(function(product) {
        product.querySelector('.button-add-to-cart').classList.add('d-none');
        product.querySelector('.btn-premium-subscribe').classList.remove('d-none');
    });
}

export function getProductConfigurationViews(productId, productReference)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product-list/get-product-configuration-views',
            {productId: productId},
            function (data) {
                ga4TrackSimpleEvent({
                    event: 'quick_purchase',
                    method: 'open',
                    content_type: productReference || ''
                });
                resolve([data.mainView, data.views]);
            },
            function (error) {
                ga4TrackSimpleEvent({
                    event: 'quick_purchase',
                    method: 'error',
                    content_type: productReference || ''
                });
                resolve([]);
            }
        );
    });
}

export async function updatePriceElements(currentConfiguration)
{
    let priceContainers = isDesktop() ? currentConfiguration.closest('.product').querySelectorAll('.product-configuration .product-configuration-information .price-container') : document.querySelectorAll('#product-list-page .offcanvas.product-configuration .product-configuration-information .price-container');
    let mainContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let inputSizes = mainContainer.querySelector('input[name="option-size"]');
    let sizes = inputSizes && inputSizes.value !== '' ? JSON.parse(inputSizes.value) : [];
    let quantity = sizes.length === 1 ? parseInt(sizes[0].quantity) : 1;

   showLoaderPriceElements(currentConfiguration);
    let [price] = await calculatePrice(mainContainer, quantity, getOptions(mainContainer), mainContainer.dataset.productId);

    if (!price) {
        priceContainers.forEach(function(priceContainer) {
            let priceText = priceContainer.querySelector('.price-text');
            let mainPrice = priceContainer.closest('.product-configuration-main');

            if (mainPrice) {
                let priceValue = priceText.querySelector('.price-value');
                let oldPrice = priceText.closest('.product-configuration').querySelector('.old-price');
                priceText.closest('.price').querySelector('.price-of').classList.remove('d-none');
                priceValue.innerHTML = priceValue.dataset.defaultPrice;
                if (oldPrice) oldPrice.classList.remove('d-none');
                if (oldPrice && !oldPrice.classList.contains('text-danger')) priceText.classList.add('text-danger');

            } else {
                priceText.innerHTML = '';
            }

            hideElement(priceContainer.querySelector('.loader'));
            if (mainPrice) showElement(priceContainer.querySelector('.price'));
        });
    } else {
        priceContainers.forEach(function(priceContainer) {
            let priceText = priceContainer.querySelector('.price-text');
            let mainPrice = priceContainer.closest('.product-configuration-main');
            price = formatPrice(price);

            if (mainPrice) {
                let priceOf = priceText.closest('.price').querySelector('.price-of');
                let oldPrice = priceText.closest('.product-configuration').querySelector('.old-price');

                if (!priceOf.classList.contains('d-none')) priceOf.classList.add('d-none');
                if (oldPrice && !oldPrice.classList.contains('d-none')) oldPrice.classList.add('d-none')
                priceText.querySelector('.price-value').innerHTML = price;
                priceText.classList.remove('text-danger');
            } else {
                priceText.innerHTML = price;
            }

            hideElement(priceContainer.querySelector('.loader'));
            showElement(priceContainer.querySelector('.price'));
        });
    }
}

export function showLoaderPriceElements(currentConfiguration)
{
    let priceContainers = isDesktop() ? currentConfiguration.closest('.product').querySelectorAll('.product-configuration .product-configuration-information .price-container') : document.querySelectorAll('#product-list-page .offcanvas.product-configuration .product-configuration-information .price-container');
    priceContainers.forEach(function(priceContainer) {
        hideElement(priceContainer.querySelector('.price'));
        showElement(priceContainer.querySelector('.loader'));
    });
}

export function getOptions(container)
{
    let options = {};

    container.querySelectorAll('input.option-value').forEach(function(option) {
        let optionName = option.dataset.optionName;

        if (optionName === 'size') {
            let sizes = option.value !== '' ? JSON.parse(option.value) : [];
            if (sizes.length === 0) return;
            if (sizes.length === 1) options = {...options, ...sizes[0]};
            else options['sizes'] = sizes;
        } else if (optionName === 'customizer') {
            if (option.value === '') return;
            options = {...options, ...JSON.parse(option.value)};
        } else if (optionName === 'vinyl-rug-format') {
            options['format'] = option.value;
        } else {
            options[optionName] = option.value;
        }
    });

    if (options.hasOwnProperty('quantity')) delete options['quantity'];

    return options;
}

function getComplements(container)
{
    let complements = [];

    let complementsData = container.querySelector('input[name="complements"]').value;
    complementsData = complementsData !== '' ? JSON.parse(complementsData) : [];

    complementsData.forEach(function(complement) {
        complements.push(
            {
                id: complement.id,
                price: complement.price,
                quantity: complement.quantity,
                isLocked: complement.isLocked,
                linkToParent: complement.linkToParent,
                options: {
                    width: complement.width,
                    height: complement.height,
                    device: complement.device,
                    composition: complement.composition
                }
            }
        );
    });

    return complements;
}

export function updateConfigurationStepPoints()
{
    document.querySelectorAll('#product-list-page .product-configuration:not(.product-configuration-main)').forEach(function(container) {
        container.querySelectorAll('.product-configuration-step-point').forEach(function(stepPoint) {
            let configuration = document.querySelector(`.product-configuration[data-configuration-number="${stepPoint.dataset.number}"]`);
            let configurationCompleted = configuration.dataset.completed === 'true';

            if (configurationCompleted) {
                stepPoint.classList.remove('bg-button-info', 'bg-secondary');
                stepPoint.classList.add('bg-green');
            } else if (container.dataset.configurationNumber === stepPoint.dataset.number) {
                stepPoint.classList.remove('bg-secondary', 'bg-green');
                stepPoint.classList.add('bg-button-info');
            } else {
                stepPoint.classList.remove('bg-button-info', 'bg-green');
                stepPoint.classList.add('bg-secondary');
            }
        });
    });
}

export function updateConfigurationButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration:not(.product-configuration-main)').forEach(function(configuration) {
        let isCompleted = configuration.dataset.completed === 'true';
        let footer = configuration.querySelector('.footer');
        let continueConfigurationButton = configuration.querySelector('.continue-configuration');
        let addToCartButton = configuration.querySelector('.btn-add-to-cart');
        let configurationsRemaining = document.querySelectorAll('#product-list-page .product-configuration[data-completed="false"]:not(.product-configuration-main)').length;
        let mainContainer = isDesktop() ? configuration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
        let mainContainerAddToCartButton = mainContainer.querySelector('.btn-add-to-cart');

        if (isCompleted) {
            if (configurationsRemaining) {
                hideElement(addToCartButton);
                hideElement(mainContainerAddToCartButton);
                showElement(continueConfigurationButton);
            } else {
                hideElement(continueConfigurationButton);
                showElement(addToCartButton);
                showElement(mainContainerAddToCartButton);
            }
            slideDown(footer);
        } else {
            hideElement(continueConfigurationButton);
            hideElement(addToCartButton);
            hideElement(mainContainerAddToCartButton);
            slideUp(footer);
        }
    });
}

export async function updateSizesPrices(currentConfiguration)
{
    let mainContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let productId = mainContainer.dataset.productId;
    let sizesContainer = isDesktop() ? currentConfiguration.closest('.product').querySelector('.product-configuration-size') : document.querySelector('#product-list-page .offcanvas.product-configuration-size');
    let options = getOptions(mainContainer);
    let prices = await getSizesPrices(mainContainer, options);

    prices.forEach(function (element) {
        let id = element.id;
        let price = element.price;
        let oldPrice = element.oldPrice;
        let quantitiesDiscount = element.quantitiesDiscount;
        let input = sizesContainer.querySelector(`input[name="size"][data-id="${id}"]`);
        let quantitySelector = input ? input.nextElementSibling.querySelector('.quantity-selector') : null;
        let priceElement = sizesContainer.querySelector(`label[for="${input.id}"] .size-price`);
        let oldPriceElement = sizesContainer.querySelector(`label[for="${input.id}"] .size-old-price`);

        if (priceElement) priceElement.innerHTML = price;
        if (oldPriceElement) oldPriceElement.innerHTML = oldPrice;
        if (quantitySelector && quantitiesDiscount) {
            quantitiesDiscount.forEach(function (quantityDiscount) {
                let quantity = quantityDiscount.quantity;
                let text = quantityDiscount.text;
                let price = quantityDiscount.price;
                let tomselectOption = quantitySelector.tomselect.getOption(quantity);
                let option = quantitySelector.querySelector(`option[value="${quantity}"]`);

                if (tomselectOption) tomselectOption.querySelector('.item-price').innerHTML = text;
                if (option) {
                    option.dataset.rawPrice = price;
                    option.dataset.price = text;
                }
            });
        }

    });

    //CUSTOM SIZE
    let customSizeInput = sizesContainer.querySelector(`input[name="size"][value="custom-size"]`);
    if (customSizeInput && customSizeInput.dataset.width && customSizeInput.dataset.height) {
        let customSizeContainer = sizesContainer.querySelector('.custom-size');
        let width = customSizeInput.dataset.width;
        let height = customSizeInput.dataset.height;
        let pack = mainContainer.querySelector('input[name="option-pack"]');
        let color = mainContainer.querySelector('input[name="option-color"]');
        let supportColor = mainContainer.querySelector('input[name="option-supportColor"]');

        let responseCalculatePrice = await calculateCustomSizePrice(
            productId,
            width,
            height,
            pack ? pack.value : null,
            color ? color.value : null,
            supportColor ? supportColor.value : null
        );
        let price = responseCalculatePrice.price;

        price = formatPrice(price);
        customSizeContainer.querySelectorAll('.custom-price').forEach(function(priceContainer) {
            priceContainer.querySelector('.price, .value').innerHTML = price;
        });
    }
}

export async function goToConfiguration(currentConfiguration, configurationToGo)
{
    if (isDesktop()) {
        await fadeOut(currentConfiguration, 50);
        fadeIn(configurationToGo, 200, 'flex');
    } else {
        currentConfiguration.style.transition = 'none';
        currentConfiguration.classList.remove('offcanvas-bottom');
        currentConfiguration.classList.add('offcanvas-end');
        setTimeout(() => currentConfiguration.style.transition = '', 1);

        configurationToGo.style.transition = 'none';
        configurationToGo.classList.remove('offcanvas-bottom');
        configurationToGo.classList.add('offcanvas-end');
        setTimeout(() => configurationToGo.style.transition = '', 1);

        setTimeout(function() {
            hideOffcanvasByDomObject(currentConfiguration);
            showOffcanvasByDomObject(configurationToGo);
        }, 1);
    }

    currentConfiguration.classList.remove('open');
    configurationToGo.classList.add('open');
}

export async function addToCartMultiSize(mainContainer)
{
    showLoaderAddToCartButtons();

    let productId = mainContainer.dataset.productId;
    let productType = mainContainer.dataset.productType || '';
    let currentConfigurationOpened = isDesktop() ? mainContainer.closest('.product').querySelector('.product-configuration.open') : document.querySelector('#product-list-page .offcanvas.product-configuration.open');
    let options = getOptions(mainContainer);
    let complements = getComplements(mainContainer);
    let customizeSVG = mainContainer.querySelector('input[name="customizeSVG"]') ? mainContainer.querySelector('input[name="customizeSVG"]').value === 'true' : false;
    let products = [];

    options.sizes.forEach(function(size, index) {
        let finalOptions = {...options};
        delete finalOptions.sizes;
        finalOptions['width'] = size.width || '';
        finalOptions['height'] = size.height || '';
        finalOptions['device'] = size.device || '';
        finalOptions['composition'] = size.composition || '';

        let data = {
            productId: productId,
            quantity: size.quantity,
            options: finalOptions,
            isLocked: false
        }

        if (index === options.sizes.length - 1) data['extraProducts'] = complements;

        products.push(data);
    });

    if (customizeSVG && options['personalizedText'] && options['personalizedText'] !== '-') {
        let svgResponse = await getSvgPreviewImage(productId, options['personalizedText'], options['color']);

        products.forEach(function(product) {
            product['options']['personalizedSvg'] = convertSvgToBase64(svgResponse.svg);
            product['options']['personalizedImagePreview'] = svgResponse.svgPreview;
        });
    }

    let response = await addItems(products);
    let error = response.error;
    let message = response.message;
    let type = response.type;
    let items = response.items;

    hideLoaderAddToCartButtons();

    if (error) {
        let configuration = isDesktop() ? mainContainer.closest('.product').querySelector(`.product-configuration-${type}`) : document.querySelector(`#product-list-page .offcanvas.product-configuration-${type}`);
        let errorElement = configuration.querySelector('.error.general-error');

        errorElement.innerHTML = message;
        slideDown(errorElement);
        configuration.querySelector('.body').scrollTop = 0;
        trackProductPageGa4Events('AddToCartError', type);
    } else {
        if (isDesktop()) fadeOut(currentConfigurationOpened)
        else hideOffcanvasByDomObject(currentConfigurationOpened);
        openCart();
        updateItemsNumber(true);
        trackProductPageGa4Events('AddToCartQuickPurchase', productType);
        sendEventsAddToCart(items);
    }
}

export async function addToCart(mainContainer)
{
    showLoaderAddToCartButtons();

    let productId = mainContainer.dataset.productId;
    let productType = mainContainer.dataset.productType || '';
    let currentConfigurationOpened = isDesktop() ? mainContainer.closest('.product').querySelector('.product-configuration.open') : document.querySelector('#product-list-page .offcanvas.product-configuration.open');
    let options = getOptions(mainContainer);
    let complements = getComplements(mainContainer);
    let inputSizes = mainContainer.querySelector('input[name="option-size"]');
    let sizes = inputSizes && inputSizes.value !== '' ? JSON.parse(inputSizes.value) : [];
    let quantity = sizes.length === 1 ? parseInt(sizes[0].quantity) : 1;
    let customizeSVG = mainContainer.querySelector('input[name="customizeSVG"]') ? mainContainer.querySelector('input[name="customizeSVG"]').value === 'true' : false;

    if (customizeSVG && options['personalizedText'] && options['personalizedText'] !== '-') {
        let svgResponse = await getSvgPreviewImage(productId, options['personalizedText'], options['color']);
        options['personalizedSvg'] = convertSvgToBase64(svgResponse.svg);
        options['personalizedImagePreview'] = svgResponse.svgPreview;
        if (svgResponse.svgData) {
            options['generateSVGPersonalizedText'] = {
                'text': svgResponse.svgData.text,
                'svgFile': svgResponse.svgData.svgFile,
                'font': svgResponse.svgData.font,
                'color': svgResponse.svgData.color,
                'rightToLeft': svgResponse.svgData.rightToLeft
            };
        }
    }

    let data = {
        productId: mainContainer.dataset.productId,
        quantity: quantity,
        options: options,
        isLocked: false,
        extraProducts: complements
    }

    let response = await addItem(data);
    let error = response.error;
    let message = response.message;
    let type = response.type;
    let items = response.items;

    hideLoaderAddToCartButtons();

    if (error) {
        let configuration = isDesktop() ? mainContainer.closest('.product').querySelector(`.product-configuration-${type}`) : document.querySelector(`#product-list-page .offcanvas.product-configuration-${type}`);
        let errorElement = configuration.querySelector('.error.general-error');

        errorElement.innerHTML = message;
        slideDown(errorElement);
        configuration.querySelector('.body').scrollTop = 0;
        if (currentConfigurationOpened !== configuration) goToConfiguration(currentConfigurationOpened, configuration);
        trackProductPageGa4Events('AddToCartError', type);
    } else {
        if (isDesktop()) fadeOut(currentConfigurationOpened)
        else hideOffcanvasByDomObject(currentConfigurationOpened);
        openCart();
        updateItemsNumber(true);
        trackProductPageGa4Events('AddToCartQuickPurchase', productType);
        sendEventsAddToCart(items);
    }
}

function showLoaderAddToCartButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration .btn-add-to-cart').forEach(function(button) {
        button.disabled = true;
        button.querySelector('.text').classList.add('d-none');
        button.querySelector('.loader').classList.remove('d-none');
    });
}

function hideLoaderAddToCartButtons()
{
    document.querySelectorAll('#product-list-page .product-configuration .btn-add-to-cart').forEach(function(button) {
        button.disabled = false;
        button.querySelector('.loader').classList.add('d-none');
        button.querySelector('.text').classList.remove('d-none');
    });
}

export function addComplement(complementInput)
{
    let configurationMain = isDesktop() ? complementInput.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let complementsInput = configurationMain.querySelector('input[name="complements"]')
    let complements = complementsInput.value !== '' ? JSON.parse(complementsInput.value) : [];

    if (!(complements.some(complement => complement.id === complementInput.value))){
        complements.push(
            {
                'id': complementInput.value,
                'width': complementInput.dataset.width,
                'height': complementInput.dataset.height,
                'device': complementInput.dataset.device,
                'composition': complementInput.dataset.composition,
                'price': complementInput.dataset.price,
                'quantity': 1,
                'isLocked': complementInput.dataset.locked === 'true',
                'linkToParent': complementInput.dataset.linkToParent === 'true'
            }
        );
    }

    complementsInput.value = JSON.stringify(complements);
}

export function removeComplement(complementInput)
{
    let configurationMain = isDesktop() ? complementInput.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let complementsInput = configurationMain.querySelector('input[name="complements"]')
    let complements = complementsInput.value !== '' ? JSON.parse(complementsInput.value) : [];
    let index = complements.findIndex(complement => complement.id === complementInput.value);

    if (index !== -1) complements.splice(index, 1);

    complementsInput.value = JSON.stringify(complements);
}

export function updateOpenConfigurationButtons()
{
    if (isPremiumUser()) {
        document.querySelectorAll('#product-list-page .exclusive-premium-product').forEach(function(product) {
            let button = product.querySelector('.btn-configure-product');
            if (!button) return;
            showElement(button);
        });
    }
}